module.exports = __webpack_public_path__ + "static/Museo300-Regular-2cb8e5fac1521e494473e020abb046a8.woff";